/* eslint-disable func-call-spacing */
import ('./bootstrap');
